export default "__VITE_ASSET__68a60766__"